import React from 'react';
import { useIntl } from '../../util/reactIntl';
import { ExternalLink, LinkedLogo, NamedLink } from '../../components';
import classNames from 'classnames';

import css from './FooterContainer.module.css';
import Icons from '../../components/Icons/Icons';

function FooterContainer(props) {
  const { viewport } = props;
  const intl = useIntl();

  return (
    <div className={css.footer}>
      <div className={css.footerTop}>
        <div className={css.contentWidth}>
          <div className={css.leftBlock}>
            <div className={css.linksBlock}>
              <div className={css.logo}>
                <LinkedLogo className={css.logoLink} layout="desktop" />
              </div>
              <p>
                The All-in-One Platform for Wholesale Books and Media.
              </p>
            </div>
          </div>
          <div className={css.rightBlock}>
            <div className={css.linksBlock}>
              <h2>Company</h2>
              <NamedLink className={css.link} name="LandingPage">
                About
              </NamedLink>
              <NamedLink className={css.link} name="LandingPage">
                Contact
              </NamedLink>
            </div>
            <div className={css.linksBlock}>
              <h2>Other</h2>
              <ExternalLink href="/privacy-policy" className={css.link}>
                Privacy Policy
              </ExternalLink>
              <ExternalLink href="/terms-of-service" className={css.link}>
                Terms and Conditions
              </ExternalLink>
            </div>
          </div>
        </div>
      </div>
      <div className={css.footerBottom}>
        <div className={css.contentWidth}>
          <div className={css.footerBottomLeft}>
            <p>© 2025 LibroLoop. All rights reserved.</p>
          </div>
          <div className={css.footerBottomRight}>
            <ExternalLink href="https://www.facebook.com" className={css.link}>
              <Icons name="facebook" />
            </ExternalLink>{' '}
            <ExternalLink href="https://www.instagram.com" className={css.link}>
              <Icons name="instagram" />
            </ExternalLink>{' '}
            <ExternalLink className={css.link} href="https://www.linkedin.com">
              <Icons name="linkedin" />
            </ExternalLink>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FooterContainer;
